import { fromJS } from 'immutable';

export default {
    setHomeProductsInitialized: (state, homeId) => {
        return state.setIn(['list', homeId, 'productsInitialized'], true);
    },
    setHomes: (state, homes) => {
        return state.setIn(['list'], fromJS(homes)).set('initialized', true);
    },
    setHistoryActions: (state, historyActions) => {
        return state.set('historyActions', fromJS(historyActions));
    },
    updateHomes: (state, homes) => {
        return state.mergeDeepIn(['list'], fromJS(homes));
    },
    updateHome: (state, homeId, homeDetails) => {
      return state.mergeDeepIn(['list', homeId], fromJS(homeDetails));
    }
};



// WEBPACK FOOTER //
// ./environments/fhe/data/Homes/core.js